<template>
  <div v-if="images.length" class="multi_img" :class="classObject">
    <img
      v-for="(image, index) in thumbImages"
      :key="index"
      v-lazy="image"
      @click.stop="onPreview(index)"
    />
  </div>
</template>

<script>
import { ImagePreview } from 'vant'

const thumbStyle = 'x-oss-process=style/record_pic'
const previewStyle = 'x-oss-process=style/record_preview_pic'

export default {
  name: 'MultiImg',
  components: {
  },
  props: {
    images: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      thumbImages: [],
      previewImages: []
    }
  },
  created () {
    this.thumbImages = this.images.map((item) => {
      return `${item}?${thumbStyle}`
    })
    this.previewImages = this.images.map((item) => {
      return `${item}?${previewStyle}`
    })
  },
  computed: {
    classObject () {
      return {
        'four_display': this.images.length <= 4,
        'nine_display': this.images.length > 4
      }
    }
  },
  methods: {
    onPreview (index) {
      ImagePreview({
        images: this.previewImages,
        startPosition: index,
        closeOnPopstate: true,
        onClose () {
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.multi_img {
  display: flex;
  flex-wrap: wrap;
  width: 345px;
  margin-bottom: 15px;
  &.four_display {
    width: 330px;
  }
  &.nine_display {
    width: 345px;
  }
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    margin: 15px 15px 0 0;
  }
}
</style>
